// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const fontFamilies = {
  heading: 'Poppins',
  body: 'Poppins',
  monospace: 'Fira Code'
} as const;

export default fontFamilies;
